// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2AtOS","col":"styles_col__1gCv-"};